import { render, staticRenderFns } from "./TrainerSettings.vue?vue&type=template&id=3822a0a2&scoped=true"
import script from "./TrainerSettings.vue?vue&type=script&lang=js"
export * from "./TrainerSettings.vue?vue&type=script&lang=js"
import style0 from "./TrainerSettings.vue?vue&type=style&index=0&id=3822a0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822a0a2",
  null
  
)

export default component.exports